import { Toast, Dialog } from 'vant';


export default {
    data() {
        return {
            user: {},
            exchangeInfo: {},
            giftName: '',
            memberId: this.$route.query.memberId,
            exchangeName: this.$route.query.exchangeName
        };
    },
    methods: {
        exchange(){
            if(this.exchangeInfo.num === 0){
                Dialog.alert({
                    message: '数量不足',
                    theme: 'round-button',
                }).then(() => {
                    // on close
                });
            }else if(this.user.totalScore < this.exchangeInfo.score){
                Dialog.alert({
                    message: '积分不足',
                    theme: 'round-button',
                }).then(() => {
                    // on close
                });
            }else {
                this.$api.exchangeGift({
                    params: {
                        memberId: this.user.memberId,
                        exchangeName: this.exchangeInfo.name,
                    },
                    success: function (res) {
                        console.log(":::exchangeInfo:", res)
                        Dialog.alert({
                            message: `${res.data.msg}`,
                            theme: 'round-button',
                        }).then(() => {
                            this.user = res.data.user
                            this.exchangeInfo = res.data.exchange
                            console.log(":::this.user:", this.user)
                            console.log(":::this.exchangeInfo:", this.exchangeInfo)
                        });
                    }.bind(this)
                })
            }
        },
        goUrl() {
            this.$router.push({
                path: '/dycbaexchangerecode',
                query: {
                    memberId: this.user.memberId
                }
            })
        }
    },
    created(){
        this.giftName = (this.exchangeName === 'ball'? '篮球' : '门票')
    },
    mounted(){
        // this.$api.getexchangeScoreInfo({
        //     params: {
        //         memberId: this.memberId,
        //         exchangeName: this.exchangeName,
        //     },
        //     success: function (res) {
        //         console.log(":::exchangeScoreInfo:", res)
        //         this.user = res.data.user
        //         this.exchangeInfo = res.data.exchange
        //     }.bind(this)
        // })
    }
};
